// Domaine sans cookie : rien n'est depose tant que l'iframe n'existe pas, et
// l'iframe n'est construite qu'au clic de l'utilisateur.
const EMBED_BASE = 'https://www.youtube-nocookie.com/embed/';

export function buildYoutubeIframe(videoId, title) {

    const $iframe = document.createElement('iframe');

    $iframe.src = `${EMBED_BASE}${videoId}?autoplay=1&rel=0`;
    $iframe.title = title || '';
    $iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
    $iframe.allowFullscreen = true;
    $iframe.setAttribute('frameborder', '0');

    return $iframe;
}
